import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = (location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = match && match[1];
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        const dest = data.role === "admin" ? "/admin" : data.role === "planner" ? "/planner" : "/portal";
        navigate(dest, { replace: true, state: { user: data } });
      } catch (e) {
        setError(formatApiError(e));
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-ink text-white flex flex-col items-center justify-center px-6" data-testid="auth-callback">
      {error ? (
        <div className="text-center" data-testid="auth-callback-error">
          <p className="font-display font-bold text-xl text-red-400">{error}</p>
          <Link to="/login" className="mt-4 inline-block text-sm text-neon underline" data-testid="auth-callback-back">Back to sign in</Link>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-4" data-testid="auth-callback-loading">
          <div className="h-9 w-9 rounded-full border-2 border-neon border-t-transparent animate-spin" />
          <p className="text-sm text-slate-400">Signing you in with Google…</p>
        </div>
      )}
    </div>
  );
}
